import { createAsyncThunk } from '@reduxjs/toolkit';
import { getStlife, getStlifeImages } from '../../services/studentLife';

export const getStlifeList = createAsyncThunk(
    'stlife',
    async (data, { getState, rejectWithValue }) => {
      try {
        const token = getState().auth.token;
        const response = await getStlife(data, token.token);
        
        return { data: response.data.list, total: response.data.total };
      } catch (err) {
        console.log(err.response.data.error)        
        return rejectWithValue(err.response?.data?.error || 'Failed to fetch student life');
      }
    }
  );

export const getStlifeImagesById = createAsyncThunk(
    'stlifeimages',
    async (id, { getState, rejectWithValue }) => {
      try {
        const token = getState().auth.token;
        const response = await getStlifeImages(id, token.token);
        
        return { data: response.data.data, total: response.data.data.length };
      } catch (err) {
        console.log(err.response.data.error)        
        return rejectWithValue(err.response?.data?.error || 'Failed to fetch student life');
      }
    }
  );
  